import { polymorphicFactory, Box, Spacer, Grid, GridColumn, Typography, DsmColor, omitText, Button, Carousel, CarouselSlide } from '@kohler-dsm-library/kohler-core';
import { clsx } from 'clsx';
import React from 'react';
import classes from './CompareSlider.module.css.mjs';
import { ExperienceCompareCard } from './subcomponents/ExperienceCompareCard/ExperienceCompareCard.mjs';

const CompareSlider = polymorphicFactory(
  (props, ref) => {
    const { component = "section", mod = "white", heading, cards, CTA, topSpacer, bottomSpacer, carouselProps, className, ...rest } = props;
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        component,
        className: clsx("kohler-compare-slider-root", classes.compareSliderContainer, className),
        ref,
        mod,
        ...rest
      },
      topSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...topSpacer }),
      /* @__PURE__ */ React.createElement(Grid, { className: classes.compareSliderGrid }, (heading || CTA) && /* @__PURE__ */ React.createElement(GridColumn, { className: clsx(classes.compareSliderContentContainer) }, /* @__PURE__ */ React.createElement(Typography, { component: heading.component || "h2", ...omitText(heading), size: "h2", textColor: DsmColor.ContentPrimary }, heading.text), CTA && /* @__PURE__ */ React.createElement(Button, { component: "a", ...omitText(CTA), variant: "secondary", size: "medium" }, CTA.text)), /* @__PURE__ */ React.createElement(GridColumn, { className: clsx(classes.compareCarouselSliderGrid) }, /* @__PURE__ */ React.createElement(
        Carousel,
        {
          withControls: true,
          includeGapInSize: false,
          slideSize: 0,
          slideGap: "20px",
          align: "start",
          loop: false,
          containScroll: "trimSnaps",
          hideControlOnDisabled: false,
          carouselControlProps: {
            isOnPhoto: false,
            variant: "slider"
          },
          dragIgnoreElementsList: ["span", "p", "ul", "li", "a", "button"],
          ...carouselProps
        },
        cards.map((card, index) => /* @__PURE__ */ React.createElement(CarouselSlide, { key: card.title.text || `compare-card-${index}` }, /* @__PURE__ */ React.createElement(ExperienceCompareCard, { ...card })))
      ))),
      bottomSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...bottomSpacer })
    );
  }
);

export { CompareSlider };
